<template>
    <div>
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            ref="highcharts"
        ></highcharts>
    </div>
</template>
<script>
export default {
    props: [
        'historicSalesMonth',
        'historicStocksMonth',
        'demands',
        'onHandleActiveDemand',
        'onHandleDrop'
    ],
    methods: {},
    data() {
        return {
            edithighcharts: this.editchart,
            chartOptions: {
                chart: {
                    height: '285px'
                },
                title: {
                    text: 'Historico e Previsão de Faturamento e Estoque'
                },
                gui: {
                    enabled: true
                },
                navigator: {
                    enabled: false
                },
                rangeSelector: {
                    inputEnabled: false,
                    buttons: [
                        {
                            type: 'week',
                            text: '1w'
                        },
                        {
                            type: 'month',
                            count: 6,
                            text: '2w'
                        },
                        {
                            type: 'month',
                            text: '1m'
                        },
                        {
                            type: 'year',
                            count: 1,
                            text: '6m'
                        },
                        {
                            type: 'all',
                            text: 'All'
                        }
                    ]
                },
                yAxis: {
                    title: {
                        text: 'Faturamento'
                    }
                },
                xAxis: {
                    type: 'datetime',
                    dateTimeLabelFormats: {
                        month: '%b %y',
                        year: '%Y'
                    },
                    title: {
                        text: 'Date'
                    }
                },
                legend: {
                    align: 'right',
                    verticalAlign: 'bottom',
                    borderWidth: 0
                },

                tooltip: {
                    crosshairs: true,
                    shared: true
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    spline: {
                        marker: {
                            radius: 4,
                            lineColor: '#666666',
                            lineWidth: 1
                        }
                    },
                    series: {
                        point: {
                            events: {
                                drop: event => {
                                    const chart = this.$refs.highcharts.chart
                                    let series = []
                                    for (
                                        let i = 0;
                                        i < chart.series.length;
                                        i++
                                    ) {
                                        const demand_id =
                                            chart.series[i].options.id
                                        if (demand_id) {
                                            const items = chart.series[
                                                i
                                            ].data.map(item => [
                                                item.x,
                                                item.y,
                                                demand_id
                                            ])
                                            series.push([items])
                                        }
                                    }
                                    this.onHandleDrop(series)
                                }
                            }
                        },

                        events: {
                            click: event => {
                                const demand_id = event.point.series.options.id
                                if (demand_id) {
                                    const chart = this.$refs.highcharts.chart
                                    for (
                                        let i = 0;
                                        i < chart.series.length;
                                        i++
                                    ) {
                                        if (chart.series[i].options.id)
                                            chart.series[i].update({
                                                opacity: 0.2,
                                                dragDrop: {
                                                    draggableY: false
                                                },
                                                cursor: 'default'
                                            })
                                    }
                                    event.point.series.update({
                                        opacity: 1,
                                        dragDrop: {
                                            draggableY: true
                                        },
                                        cursor: 'ns-resize'
                                    })
                                    event.point.series.setState('inactive')
                                    this.onHandleActiveDemand({
                                        ...event.point.series.options.data,
                                        demand_id
                                    })
                                }
                            }
                        }
                    }
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom'
                                }
                            }
                        }
                    ]
                }
            }
        }
    },
    watch: {
        historicSalesMonth: {
            handler: function(val) {
                const chart = this.$refs.highcharts.chart
                chart.addSeries({
                    name: 'Faturamento Histórico',
                    data: val
                })
            },
            deep: true
        },
        historicStocksMonth: {
            handler: function(val) {
                const chart = this.$refs.highcharts.chart
                chart.addSeries({
                    name: 'Estoque Histórico',
                    data: val
                })
            },
            deep: true
        },
        demands: {
            handler: function(val) {
                this.$nextTick(() => {
                    if (
                        val &&
                        Object.keys(val).length === 0 &&
                        Object.getPrototypeOf(val) === Object.prototype
                    ) {
                        const chart = this.$refs.highcharts.chart

                        while (chart.series.length) {
                            chart.series[0].remove()
                        }
                    } else {
                        const chart = this.$refs.highcharts.chart
                        val.map(item => {
                            chart.addSeries({
                                info: item[0],
                                name: 'Demanda Histórico',
                                data: item[0],
                                dragDrop: {
                                    draggableY: item[0][0][3],
                                    dragMinY: 0
                                },
                                id: item[0][0][2],
                                opacity: item[0][0][3] ? 1 : 0.2,
                                cursor: item[0][0][3] ? 'ns-resize' : 'default'
                            })
                        })
                    }
                })
            },
            deep: true
        }
    }
}
</script>
